module.exports = __webpack_public_path__ + "static/img/reject.4522e08d.svg";